module.exports = __webpack_public_path__ + "static/are-you-merchant-bd37236b6e7db95b0b0881ccbb8e8e7f.png";